import { useContext } from 'react';
import { MyOrgUnitAssortmentsContext } from './MyOrgUnitAssortmentsProvider';

export const useMyOrgUnitAssortments = () => {
  const context = useContext(MyOrgUnitAssortmentsContext);
  if (!context) {
    throw new Error('useMyOrgUnitAssortments must be used within a MyOrgUnitAssortmentsProvider');
  }
  return context;
};
